/* eslint-disable no-lonely-if */
/* eslint-disable no-console */
import React, { useContext, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Footer from '../UiComponents/Footer';
import Loading from '../components/Common/Loaders/FullWidthLoader/Loading';
import LoginHeader from '../UiComponents/Header/LoginHeader';
import BannerBlock from '../UiComponents/InlinkBanner';
import { LoginContext } from '../App';
import { isInlynkGroupMissing } from '../libs/HelperContent';
import { Auth } from 'aws-amplify';

const AuthHoc = (WrappedComponent) =>
{
	return function NewComponent()
	{
		const { loading } = useContext(LoginContext);
		const sharePost = useSelector((state:any) => state?.mysession?.sharePost);
		const session = useSelector((state: any) => state?.mysession?.session);
		const navigate = useNavigate();
		const urlData = window.location.pathname;
		const searchParams = new URLSearchParams(window.location.search);
		const module:any = searchParams.get('module');
		const type:any = searchParams.get('type');
		const id:any = searchParams.get('id');
		const action:any = searchParams.get('action');

		const userMissingInCognitoGroup = async () =>
		{
			const isMissing = await isInlynkGroupMissing();

			if (isMissing && [ '/individual-signup', '/employee-signup', '/company-signup' ]?.includes(window.location.pathname))
			{
				navigate(`${window.location.pathname}?bypassCache=true`);
			}
			else
			{
				if (isMissing)
				{
					navigate('/signup?source=inmeet');
				}
				else
				{
					try
					{
						const payload = await Auth.currentAuthenticatedUser({ bypassCache: true });

						if (Object.keys(payload || {})?.length > 0)
						{
							navigate(sharePost ? `/news?post=${sharePost}` : '/news', { replace: true });
						}
					}
					catch (err)
					{
						console.error('user is not authenticated****');
						navigate('/');
					}
				}
			}

			return isMissing;
		};

		const handleNavigationToModules = async () =>
		{
			if (module === 'webinar' && [ 'updated', 'invited' ].includes(action) && type === 'speaker')
			{
				navigate(`/webinarsvc/speaker/${id}`);

				return;
			}
			else if (module === 'webinar' && [ 'registered', 'joined', 'invited' ].includes(action))
			{
				const registeredName = new URLSearchParams(window.location.search).get('name');
				const registeredEmail = new URLSearchParams(window.location.search).get('email');

				console.log('check***', module, action);
				action === 'registered'
					? navigate(`/webinarsvc/join/${id}?name=${registeredName}&email=${registeredEmail}`)
					: navigate(`/webinarsvc/register/${id}`);

				return;
			}

			if (Object.keys(session).length > 0)
			{
				if (await userMissingInCognitoGroup())
				{
					return;
				}
				if (session?.role === 'employee' &&
					[ 'pending', 'reject', 'deactive', '', undefined ].includes(session?.isActive))
				{
					navigate('/emp', { replace: true });
				}
				else if (module)
				{
					switch (module)
					{
						case 'contract':
							navigate(
								type || id
									? `/contractManagement/view/${window.btoa(id)}`
									: '/contractManagement', { replace: true }
							);
							break;
						case 'helpandsupport':
							navigate(`/helpandsupport${id ? `?id=${id}` : ''}`, { replace: true });
							break;
						case 'meeting':
							navigate(`/meetingvc/join/${window.btoa(id)}?email=${window.btoa(session?.email)}`);
							break;
						case 'webinar':
							if (action === 'registered')
							{
								const registeredName = new URLSearchParams(window.location.search).get('name');
								const registeredEmail = new URLSearchParams(window.location.search).get('email');

								navigate(`/webinarsvc/join/${id}?name=${registeredName}&email=${registeredEmail}`);
							}
							else if ([ 'recorded', 'recording' ].includes(action))
							{
								navigate(`/webinars/view/${id}?playVideo=true`);
							}
							else
							{
								navigate(`/webinarsvc/register/${id}`);
							}
							break;
						default:
							navigate(sharePost !== '' ? `/news?post=${sharePost}` : '/news?bypassCache=true', { replace: true });
							break;
					}
				}
			}
		};

		useEffect(() =>
		{
			handleNavigationToModules();
		}, [ session, module, type, id, sharePost, navigate ]);

		return (
			<div className='flexCol justifyBtwn authLayout '>
				{!loading && <LoginHeader />}
				{!loading &&
					<>
						<div className='flexRow justifyBtwn'>
							{(Object.keys(session)?.length <= 0 && urlData === '/') && <BannerBlock />}
							{/* {(Object.keys(session)?.length <= 0 && urlData === '/userSign') && <BannerBlock />} */}
							<React.Suspense fallback={<Loading/>}>
								<WrappedComponent />
							</React.Suspense>
						</div>
						<div />
						<Footer />
					</>
				}

			</div>
		);
	};
};

export default AuthHoc;